import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

const Chip = ({
  label,
  isPrimary,
  isSmall,
  isSelected,
  minWidth,
  onClick = () => {},
  icon: Icon = Fragment,
  ...props
}) => (
  <Wrapper
    isPrimary={isPrimary}
    isSmall={isSmall}
    isSelected={isSelected}
    onClick={onClick}
    minWidth={minWidth}
    {...props}
  >
    <Icon />
    <span>{label}</span>
  </Wrapper>
);

Chip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isPrimary: PropTypes.bool,
  isSmall: PropTypes.bool,
  isSelected: PropTypes.bool,
  minWidth: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.func
};

export default Chip;
